import { useDispatch, useSelector } from "react-redux";
import { RepairShop } from "../../model/RepairShop";
import { RootState } from "../../redux/reducer";
import {
  addUser,
  checkSpeedMate,
  removeUser,
  updateUserInfo,
} from "../../redux/slices/UserSlice";
import { getToken, removeToken, setToken } from "../../shared/utils";

const useUser = () => {
  const dispatch = useDispatch();
  const accountRevision = useSelector(
    (state: RootState) => state.User.accountRevision
  );
  function signIn(aId: any, token: string) {
    setToken("tirepick_repairshop_access_token", token);
    setToken("repairshop_user", JSON.stringify(aId));
    dispatch(addUser(aId));
  }
  function signOut() {
    dispatch(removeUser());
    removeToken("tirepick_repairshop_access_token");
    removeToken("repairshop_user");
  }
  function getUserID() {
    if (getToken("repairshop_user") !== null) {
      const { id } = JSON.parse(
        getToken("repairshop_user") || "name:'nologin'"
      );
      return id;
    }
    return "nologin";
  }
  function getAid() {
    if (getToken("repairshop_user") !== null) {
      const { repairShopAId } = JSON.parse(
        getToken("repairshop_user") || "name:'nologin'"
      );
      return repairShopAId;
    }
    return "nologin";
  }
  function getAdminInfo(): RepairShop | null {
    if (getToken("repairshop_user") !== null) {
      return JSON.parse(getToken("repairshop_user") || "name:'nologin'");
    }
    return null;
  }
  function updateAdminInfo(repairShop: RepairShop) {
    const currentAdminInfo = getAdminInfo();
    const updatedAdminInfo = { ...currentAdminInfo, ...repairShop };

    setToken("repairshop_user", JSON.stringify(updatedAdminInfo));
    dispatch(updateUserInfo());
  }
  function getAuth() {
    const { bosRole } = JSON.parse(
      getToken("repairshop_user") || "bosRole:'no'"
    );
    if (bosRole) {
      const { bosRoleBosMenus } = bosRole;
      const authList = bosRoleBosMenus?.map((val: any) => {
        return val.bosMenu.id;
      });

      return authList;
    }
    return [];
  }
  function checkIsSpeedMate(aId: string, token: string) {
    dispatch(checkSpeedMate());
    setToken("speedMateToken", token);
    setToken("repairshop_user", JSON.stringify(aId));
    dispatch(addUser(aId));
  }
  function checkSignIn() {
    const token = getToken("tirepick_repairshop_access_token");
    const auth = token !== null;

    return auth;
  }

  return {
    signIn,
    signOut,
    checkIsSpeedMate,
    checkSignIn,
    getUserID,
    getAuth,
    getAid,
    getAdminInfo,
    updateAdminInfo,
    accountRevision,
    getToken,
  };
};
export default useUser;
